module.exports = __webpack_public_path__ + "6e375c498e4e55a88886ca0074888338.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/customer-service-black.svg
// module id = 1318
// module chunks = 61